import { AADetectionResults } from "../types";

const BT_AA_DETECTION_KEY = "BT_AA_DETECTION";
export const setAADetectionData = (data: AADetectionResults) =>
  localStorage.setItem(BT_AA_DETECTION_KEY, JSON.stringify(data));
